import { toast } from 'react-toastify'
import React from 'react'
import Button from '@mui/material/Button'
import CommandForm from '~/client/components/CommandForm'

export default function UnshareDocumentButton({
  appAccountId,
  documentId,
  onSubmit,
  onFailure,
  onSuccess,
  ...props
}){
  return <CommandForm {...{
    ...props,
    renderError: false,
    formButtons: false,
    command: 'appAccounts.unshareDocument',
    onSubmit(value, command) {
      if (onSubmit) onSubmit(value, command)
      else command.call({ appAccountId, documentId })
    },
    onFailure(error){
      toast.error(`${error}`)
      if (onFailure) onFailure(error)
    },
    onSuccess(){
      toast.success('Document unshared!')
      if (onSuccess) onSuccess()
    },
  }}>{({ submitting }) => (
    <Button
      type="submit"
      variant="outlined"
      color="error"
    >{submitting ? 'UNSHARING…' : 'UNSHARE'}</Button>
  )}</CommandForm>
}
